export const REQUEST_RESULTS = 'explorer/REQUEST_RESULTS';
export const RECEIVE_RESULTS = 'explorer/RECEIVE_RESULTS';
export const RECEIVE_FAILURE = 'explorer/RECEIVE_FAILURE';
export const REQUEST_FORM_OPTIONS = 'explorer/REQUEST_FORM_OPTIONS';
export const SET_FORM_OPTIONS = 'explorer/SET_FORM_OPTIONS';
